import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { isNativePlatform } from '@/utils/capacitor';

export function impactLight(): void {
  if (!isNativePlatform()) {
    return;
  }
  void Haptics.impact({ style: ImpactStyle.Light });
}

export function notifySuccess(): void {
  if (!isNativePlatform()) {
    return;
  }
  void Haptics.notification({ type: NotificationType.Success });
}

export function notifyError(): void {
  if (!isNativePlatform()) {
    return;
  }
  void Haptics.notification({ type: NotificationType.Error });
}
